
import {
    defineComponent,
    ref
} from 'vue';
import {
    useStore
} from '../../store';

import {
    Project
} from "@/helpers/interfaces";

import MyCardTabPictures from "@/components/TimelinePage/MyCardTabPictures.vue";
import MyCardTabVideo from "@/components/TimelinePage/MyCardTabVideo.vue";
import MyCardTabText from "@/components/TimelinePage/MyCardTabText.vue";
import MyTechnology from "@/components/TimelinePage/MyTechnology.vue";

export default defineComponent({

    setup() {
        const store = useStore();
        const state = ref(store.state);

        return {
            state
        };
    },
    components: {
        MyTechnology,
        MyCardTabText,
        MyCardTabPictures,
        MyCardTabVideo
    },
    props: {
        project: {
            type: Object as() => Project,
            required: true
        },
    },
    computed: {
        canShow(): boolean {
            return this.project.technologies.some(x => this.state.selectedTechnologies.includes(x));
        }
    }

});
